<div class="fb-app-shell">
  <!--
    One rail, two roles. On a wide viewport it is permanent chrome. On a compact one it is summoned
    over the page, so it is only in the DOM while it is showing: an off-screen rail would leave its
    controls tabbable and invisible. Being created on demand is also what lets the focus trap
    capture focus on open and hand it back to the launcher on close.
  -->
  @if (!isCompact() || isRailOpen()) {
    <app-nav-rail
      class="aside d-print-none"
      [cdkTrapFocus]="isCompact()"
      [cdkTrapFocusAutoCapture]="isCompact()"
      [animate.enter]="railEnterClass()" />
  }

  @if (isRailOpen()) {
    <div class="fb-app-shell__scrim" aria-hidden="true" (click)="closeRail()"></div>
  }

  @if (isCompact() && !isRailOpen() && !launcherInPage()) {
    <!--
      The way into the rail on a compact viewport. It floats rather than sitting in the app bar
      because the bar has no width to spare, and bottom-left is both the easiest corner to reach
      one-handed and the one the Intercom launcher does not already occupy.
    -->
    <button
      type="button"
      class="fb-app-shell__nav-launcher"
      aria-expanded="false"
      aria-controls="fb-app-rail"
      [attr.aria-label]="'SHARED.SYSTEM.MENU' | translate"
      data-testid="btn-open-nav-rail"
      (click)="openRail()">
      <mat-icon aria-hidden="true">menu</mat-icon>
    </button>
  }

  <section class="fb-app-shell__main" role="main">
    <div class="fb-app-shell__content">
      <div class="fb-app-shell__header" [class.fb-app-shell__header--elevated]="isHeaderElevated">
        <app-global-header />
      </div>
      <div
        class="fb-app-shell__page"
        [class.fb-app-shell__page--launcher-in-page]="launcherInPage()"
        #scrollContainer>
        <div #scrollSentinel class="fb-app-shell__scroll-sentinel" aria-hidden="true"></div>
        <router-outlet (activate)="routeChanged()" />
      </div>
    </div>
  </section>
</div>
